import { InstructorEducationalBackground } from "@features/instructor/types";
import MobileTabHeading from "./MobileTabHeading";
import DegreeItem from "./DegreeItem";
import Graduated from "@svg/new-design/graduated";
import { type FC } from "react";

const MobileEducationPanel: FC<{
  degrees: InstructorEducationalBackground[];
}> = ({ degrees }) => {
  return (
    <div className="py-6">
      <MobileTabHeading
        icon={Graduated}
        title="سوابق تحصیلی"
        iconClassName="text-fds-tertiary w-6  h-6"
      />
      <div className="flex flex-col-reverse gap-y-4 pt-4">
        {degrees.map((eduItem, idx) => (
          <DegreeItem
            key={idx}
            degree={eduItem.degree}
            university={eduItem.university}
            showUniversity={true}
            grade={eduItem.grade}
          />
        ))}
      </div>
    </div>
  );
};

export default MobileEducationPanel;
